<script setup>
import {reactive} from "vue";
import AmountInput from "../../../assets/components/AmountInput.vue";
import {__, _mareike_nonce, notify} from "../../../assets/javascripts/library";
import {useAjax} from "../../../assets/javascripts/useAjax";


const { request } = useAjax()


async function save() {
  const data = await request("/wp-json/mareike/costunits/create-new-cost-unit", {
    method: "POST",
    body: {
      mareike_nonce: _mareike_nonce(),
      cost_unit_name: formData.cost_unit_name,
      distance_allowance: formData.distance_allowance,
      email_address: formData.emailAddress,
      mail_on_new: formData.mainOnNew,
    }
  });

  notify('Die laufende Tätigkeit wurde erfolgreich angelegt.', 'success');
  window.location.href = '/cost-units';
}

const props = defineProps({
  email: String,
})

const formData = reactive({
  cost_unit_name: '',
  distance_allowance: '0,25',
  emailAddress: props.email,
  mainOnNew: true,

})
</script>

<template>
  <h2>Neue Laufende Tätigket</h2>
  <p>
    Hier kann eine Kostenstelle für eine laufende Tätigkeit hinzugefügt werden.<br />
    Soll dise mit einer konkreten Veranstaltung in Verbindung gebracht werden, erstelle bitte eine <a href="/create-new-event">neue Veranstaltung</a>.
  </p>

  <table style="margin-top: 40px; width: 100%">
    <tr>
      <th  style="width: 250px;">Name der laufenden Tätigkeit:</th>
      <td><input type="text" v-model="formData.cost_unit_name" class="mareike-text width-half-full" /></td>
    </tr>

    <tr>
      <th  style="width: 250px;">E-Mail-Adresse:</th>
      <td><input type="email" v-model="formData.emailAddress" class="mareike-text width-half-full" /></td>
    </tr>

    <tr>
      <th>Kilometerpauschale:</th>
      <td>
        <AmountInput v-model="formData.distance_allowance" class="mareike-text width-small" /> Euro / Kilometer</td>
    </tr>

    <tr>
      <td colspan="2">
        <label style="display: flex; align-items: center; cursor: pointer;">
          <input
              type="checkbox"
              id="mail_on_new"
              v-model="formData.mainOnNew"
              style="margin-right: 8px; cursor: pointer;"
          />
          <span>{{__('Send email notification on new receipts', 'mareike') }}</span>
        </label>
      </td>
    </tr>

    <tr>
      <th style="padding-top: 35px;">
        <input type="button" @click="save" value="Speichern" class="mareike-button button-small button-block" />
      </th>
      <td></td>
    </tr>
  </table>


</template>

<style scoped>

</style>